export class EmployeeDepartmentHistories {

  Id: number;
  EmpCode: number;
  DepartmentId: number;
  DepartmentName: string;
  StartDate: Date;
  EndDate: Date;
  //TechGroupId: number;
  //TechGroupName: string;
  //ExpertiseId: string;
  CreatedBy: string;
  CreatedDate: Date;
  ModifiedBy: string;
  ModifiedDate: Date;
  IsActive: boolean;
  //selectedExpertiseIds: any[] = [];
  hasDuplicateNameError?: boolean;
  duplicateNameMessage?: string;
}
